module.exports = __webpack_public_path__ + "img/22.06d33734.png";